<template>
	<div class="bigbox">
		<div id="safetytu2" class="mapmain"></div>
	</div>
</template>
<script>
	// 1.引入echarts
	import * as echarts from 'echarts'

	export default {
		props: {
			Interfacedata: {}
		},
		data() {
			return {
				myChart: null,
				colorList: ['#58D5FF', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF'],
				option: {
					title: {
						text: 'Rainfall vs Evaporation',
						subtext: 'Fake Data'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['Rainfall', 'Evaporation']
					},
					toolbox: {
						show: true,
						feature: {
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						// prettier-ignore
						data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: 'Rainfall',
							type: 'bar',
							data: [
								2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
							],
							markPoint: {
								data: [{
										type: 'max',
										name: 'Max'
									},
									{
										type: 'min',
										name: 'Min'
									}
								]
							},
							markLine: {
								data: [{
									type: 'average',
									name: 'Avg'
								}]
							}
						},
						{
							name: 'Evaporation',
							type: 'bar',
							data: [
								2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
							],
							markPoint: {
								data: [{
										name: 'Max',
										value: 182.2,
										xAxis: 7,
										yAxis: 183
									},
									{
										name: 'Min',
										value: 2.3,
										xAxis: 11,
										yAxis: 3
									}
								]
							},
							markLine: {
								data: [{
									type: 'average',
									name: 'Avg'
								}]
							}
						}
					]
				}
			}
		},
		watch: {
			// 接口数据
			Interfacedata: {
				handler(newName, oldName) {
				},
				deep: true
			}
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
				// 使用Echarts插件的时候，多次加载会出现There is a chart instance already initialized on the dom.这个错误，添加这个判断可以防止出现报错
				if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
					this.myChart.dispose();
				}
				// 基于准备好的dom，初始化echarts实例
				this.myChart = echarts.init(document.getElementById('safetytu2'))
				this.myChart.setOption(this.option)
			}
		}
	}
</script>
<style scoped lang="less">
	.bigbox{
		width: 100%;
		height: 100%;
	}
	.mapmain {
		width: 90%;
		height: 95%;
		min-height: 70vh;
		min-width: 70vw;
		font-size: 16px;
		margin:  0 auto;
		// border: 1px solid black;
	}
</style>
